import {
  updateShiftAsync,
  updateShiftStatusAsyncForCourier,
  createNewShiftList,
} from 'fetch/shiftFetch';
import {
  ShiftCourierJson,
  ShiftCourierJsonForCourier,
  ShiftStatusType,
  EmptyShift,
  ShiftCourierJsonRequest,
} from '../../const/ShiftConst';
import { CourierJson } from 'types/bundleTypes';
import { v4 as uuidv4 } from 'uuid';
import dayjs, { Dayjs } from 'dayjs';
import { Region } from '../../types/orderTypes';

export async function makeUpdatedShiftStatusForRequestedCourier(
  shiftCourier: ShiftCourierJsonForCourier,
  name: string,
  status: ShiftStatusType,
  courierId: number
): Promise<ShiftCourierJsonForCourier> {
  if (shiftCourier.courierId === courierId || shiftCourier.courierId === null) {
    const updateObject: ShiftCourierJsonForCourier = {
      id: shiftCourier.id,
      name: name,
      courierId: courierId,
      status: status,
      extraWork: shiftCourier.extraWork,
    };
    const ShiftCourierResponse: boolean =
      await updateShiftStatusAsyncForCourier(shiftCourier.id, updateObject);
    if (ShiftCourierResponse) {
      return updateObject;
    } else {
      const deletedObject: ShiftCourierJsonForCourier = {
        id: shiftCourier.id,
        name: name,
        courierId: courierId,
        status: ShiftStatusType.DELETED,
        extraWork: shiftCourier.extraWork,
      };
      return deletedObject;
    }
  } else {
    return shiftCourier;
  }
}

async function makeUpdatedShiftForRequestedCourier(
  shiftCourier: ShiftCourierJson,
  name: string,
  status: ShiftStatusType,
  courierId: number
) {
  if (shiftCourier.courierId === courierId) {
    // need the correct object here that i will update.

    console.log(
      'shiftCourier.extraWork in making booked shift ',
      shiftCourier.extraWork
    );

    const updateObject: ShiftCourierJson = {
      id: shiftCourier.id,
      name: name,
      courierId: courierId,
      note: shiftCourier.note,
      extraWork: shiftCourier.extraWork,
      status: status,
      shiftTravelMode: shiftCourier.shiftTravelMode,
    };

    const ShiftCourierResponse: boolean = await updateShiftAsync(
      shiftCourier.id,
      updateObject
    );
    if (ShiftCourierResponse) {
      return updateObject;
    }
  } else {
    return shiftCourier;
  }
}

async function makeUpdatedShiftForOpenSpot(
  shiftCourier: ShiftCourierJson,
  selectedIndex: number,
  index: number,
  courierId: number,
  name: string,
  status: ShiftStatusType,
  shiftTravelMode: string
): Promise<ShiftCourierJson> {
  if (shiftCourier.name === EmptyShift.name && selectedIndex === index) {
    const updateObject: ShiftCourierJson = {
      id: shiftCourier.id,
      name: name,
      courierId: courierId,
      note: shiftCourier.note,
      status: status,
      extraWork: shiftCourier.extraWork,
      shiftTravelMode: shiftTravelMode,
    };
    const ShiftCourierResponse: boolean = await updateShiftAsync(
      shiftCourier.id,
      updateObject
    );

    if (ShiftCourierResponse) {
      return updateObject;
    }
  } else {
    return shiftCourier;
  }
}

export async function setCourierToBookedForShift(
  shiftCourierList: ShiftCourierJson[],
  selectedShiftCourier: ShiftCourierJson,
  setSelectedCourierShiftIndex: (index: number) => void,
  selectedStatus: ShiftStatusType,
  selectedIndex: number
): Promise<ShiftCourierJson[]> {
  const courierId: number = selectedShiftCourier.courierId;
  const name: string = selectedShiftCourier.name;

  if (shiftCourierList && shiftCourierList.length > 0) {
    setSelectedCourierShiftIndex(selectedIndex);
    if (
      shiftCourierList.filter(
        shiftCourier => shiftCourier.courierId === courierId
      ).length > 0
    ) {
      // replace courier if it allready exist
      const newShiftCourierList: ShiftCourierJson[] = await Promise.all(
        shiftCourierList.map(
          (shiftCourierObj: ShiftCourierJson, index: number) => {
            if (
              selectedShiftCourier.id === shiftCourierObj.id &&
              shiftCourierObj.status !== ShiftStatusType.DELETED
            ) {
              const updatedShiftObject: Promise<ShiftCourierJson> =
                makeUpdatedShiftForRequestedCourier(
                  shiftCourierObj,
                  name,
                  selectedStatus,
                  courierId
                );
              return updatedShiftObject;
            } else {
              return shiftCourierObj;
            }
          }
        )
      );

      return newShiftCourierList;
    } else {
      const newShiftCourierList: ShiftCourierJson[] = await Promise.all(
        shiftCourierList.map(
          (shiftCourierObj: ShiftCourierJson, index: number) => {
            if (
              selectedShiftCourier.id === shiftCourierObj.id &&
              shiftCourierObj.status !== ShiftStatusType.DELETED
            ) {
              const updatedShiftObject: Promise<ShiftCourierJson> =
                makeUpdatedShiftForOpenSpot(
                  shiftCourierObj,
                  selectedIndex,
                  index,
                  courierId,
                  name,
                  selectedStatus,
                  shiftCourierObj.shiftTravelMode
                );
              return updatedShiftObject;
            } else {
              return shiftCourierObj;
            }
          }
        )
      );
      return newShiftCourierList;
    }
  } else {
    const newShiftCourierListBug: ShiftCourierJson[] = [
      {
        id: 'unknown not set in db jet',
        name: name,
        courierId: courierId,
        note: '',
        extraWork: EmptyShift.extraWork,
        status: selectedStatus,
        shiftTravelMode: 'BUG',
      },
    ];
    return newShiftCourierListBug;
  }
}

export async function addCourierToShift(
  shiftCourierList: ShiftCourierJson[],
  selectedCourier: CourierJson,
  selectedIndex: number
): Promise<ShiftCourierJson[]> {
  const courierId: number = selectedCourier.id;
  const name = `${selectedCourier.firstName} ${selectedCourier.lastName}`;

  const status: ShiftStatusType = ShiftStatusType.REQUESTED;

  if (shiftCourierList && shiftCourierList.length > 0) {
    const newShiftCourierList: ShiftCourierJson[] = await Promise.all(
      shiftCourierList.map(
        (shiftCourierObj: ShiftCourierJson, index: number) => {
          if (shiftCourierObj.status !== ShiftStatusType.DELETED) {
            const UpdateShiftCourierObj: Promise<ShiftCourierJson> =
              makeUpdatedShiftForOpenSpot(
                shiftCourierObj,
                selectedIndex,
                index,
                courierId,
                name,
                status,
                selectedCourier.travelMode
              );
            return UpdateShiftCourierObj;
          } else {
            return shiftCourierObj;
          }
        }
      )
    );
    return newShiftCourierList;
  } else {
    const BugNewShiftCourierList: ShiftCourierJson[] = [
      {
        id: 'unknown n ot set in db jet',
        name: name,
        courierId: courierId,
        note: '',
        extraWork: EmptyShift.extraWork,
        status: status,
        shiftTravelMode: 'BUG',
      },
    ];
    return BugNewShiftCourierList;
  }
}

export async function addMultipleCourierToShift(
  shiftCourierList: ShiftCourierJson[],
  selectedCourierList: CourierJson[],
  date: Dayjs,
  region: Region
): Promise<ShiftCourierJson[]> {
  const newCourierShiftListRequest: ShiftCourierJsonRequest[] =
    selectedCourierList.map((courier: CourierJson) => {
      return {
        id: uuidv4(),
        name: courier.fullName,
        day: dayjs(date).format('YYYY-MM-DD'),
        courierId: courier.id,
        note: EmptyShift.note,
        status: ShiftStatusType.REQUESTED,
        shiftTravelMode: `${courier.travelMode}`,
      };
    });

  const response = await createNewShiftList(newCourierShiftListRequest, region);
  if (response) {
    const newCourierShiftList: ShiftCourierJson[] =
      newCourierShiftListRequest.map(obj => {
        return {
          id: obj.id,
          name: obj.name,
          courierId: obj.courierId,
          note: EmptyShift.note,
          extraWork: EmptyShift.extraWork,
          status: obj.status,
          shiftTravelMode: obj.shiftTravelMode,
        };
      });
    const newList: ShiftCourierJson[] = shiftCourierList
      ? [...shiftCourierList, ...newCourierShiftList]
      : newCourierShiftList;

    return newList;
  } else {
    window.alert('something happened, error. Please try again');
    return [];
  }
}

export async function asyncAddShiftCourierToNextDay(
  shiftCourier: ShiftCourierJson,
  date: Dayjs,
  region: Region
): Promise<ShiftCourierJson> {
  const newCourierShiftListRequest: ShiftCourierJsonRequest[] = [
    {
      id: uuidv4(),
      name: shiftCourier.name,
      day: dayjs(date).format('YYYY-MM-DD'),
      courierId: shiftCourier.courierId,
      note: EmptyShift.note,
      status: ShiftStatusType.REQUESTED,
      shiftTravelMode: shiftCourier.shiftTravelMode,
    },
  ];

  const response = await createNewShiftList(newCourierShiftListRequest, region);
  if (response) {
    const newShiftCourier: ShiftCourierJson = {
      id: newCourierShiftListRequest[0].id,
      name: newCourierShiftListRequest[0].name,
      courierId: newCourierShiftListRequest[0].courierId,
      note: newCourierShiftListRequest[0].note,
      extraWork: EmptyShift.extraWork,
      status: newCourierShiftListRequest[0].status,
      shiftTravelMode: newCourierShiftListRequest[0].shiftTravelMode,
    };
    return newShiftCourier;
  } else {
    window.alert('something happened, error. Please try again');
  }
}
